import PreviewHeader from './preview_header'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    userHasCampaigns: state.current_user.has_campaigns,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviewHeader)
